module.exports = __webpack_public_path__ + "static/media/rede-protecao-6.c613232f.jpeg";